import React from 'react';
import POCToolImgContent from './POCToolImgContent';
import POCToolParagraphContent from './POCToolParagraphContent';
import POCToolPointContent from './POCToolPointContent';
import {Box, Container} from '@mui/material';
import POCToolPdfContent from './POCToolPdfContent';
import POCToolVideoContent from './POCToolVideoContent';
import './contentHTMLStyles.css';

type Props = {
  content: {
    contentURL: string;
    type: string;
    contentText: string;
  };
};

export default function POCToolContent(props: Props) {
  const {content} = props;

  const Content = () => {
    switch (content.type) {
      case 'paragraph':
        return (
          <div className="isolated-content-wrapper">
            <div dangerouslySetInnerHTML={{__html: content.contentURL}} />
          </div>
        );
      case 'p':
        // legacy. used for old content
        return <POCToolParagraphContent contentText={content.contentText} />;
      case 'ul':
        return <POCToolPointContent contentText={content.contentText} />;
      case 'li':
        return (
          <POCToolPointContent
            contentText={content.contentText}
            indentlevel={1}
            type={'empty'}
          />
        );
      case 'img':
        return <POCToolImgContent contentURL={content.contentURL} />;
      case 'pdf':
        return <POCToolPdfContent contentURL={content.contentURL} />;
      case 'video':
        return <POCToolVideoContent contentURL={content.contentURL} />;
      default:
        return <Box />;
    }
  };
  return <Container style={styles.container}>{<Content />}</Container>;
}

const styles = {
  container: {
    width: '100%',
  },
};
